import React from "react";
import { Button, Card, Col, Row, Modal, Typography, Input } from "antd";
import { DepositWithdrawInput } from "./DepositWithdrawInput";

const { Text } = Typography;

export const FarmCard = ({
  title,
  maxDepositAmount,
  maxWithdrawAmount,
  isApprove,
  pendingReward,
  depositCoinSymbol,
  withdrawCoinSymbol,
  description,
  image,
  details,
  deposit,
  withdraw,
  approve,
  harvest,
}) => {
  const [showDetails, setShowDetails] = React.useState(false);
  const [modalVisible, setModalVisible] = React.useState(false);
  const [modal, setModal] = React.useState({ title: "", onOk: () => {} });
  const [amount, setAmount] = React.useState(0);

  const onCancel = () => {
    setModalVisible(false);
  };

  const handleDeposit = () => {
    setAmount(0);
    setModal({
      title: `Deposit ${title} Tokens`,
      onOk: deposit,
      onCancel,
      symbol: depositCoinSymbol,
      maxAmount: maxDepositAmount,
    });
    setModalVisible(true);
  };

  const handleWithdraw = () => {
    setAmount(0);
    setModal({
      title: `Withdraw ${title} Tokens`,
      onOk: withdraw,
      onCancel,
      symbol: withdrawCoinSymbol,
      maxAmount: maxWithdrawAmount,
    });
    setModalVisible(true);
  };

  return (
    <>
      <Modal
        {...{
          visible: modalVisible,
          ...modal,
          onOk: modal.onOk(amount),
        }}
      >
        <DepositWithdrawInput
          maxAmount={modal.maxAmount}
          symbol={modal.symbol}
          amount={amount}
          setAmount={setAmount}
        />
      </Modal>
      <Card title={title} extra={image}>
        <Text>{description}</Text>
        <br />
        <br />
        {isApprove ? (
          <>
            <Row>
              {pendingReward && (
                <>
                  <Col span={16}>
                    <Text strong>$WAGMI earned:</Text>
                    <br />
                    <Text>{pendingReward}</Text>
                  </Col>
                </>
              )}
            </Row>
            <Row>
              <Col span={16}>
                <Text strong>{title} staked:</Text>
                <br />
                <Text>{maxWithdrawAmount}</Text>
              </Col>
              <Col span={8}>
                <Row justify="space-around">
                  {maxWithdrawAmount ? (
                    <>
                      <Button onClick={handleWithdraw} type="default">
                        -
                      </Button>
                      <Button onClick={handleDeposit} type="default">
                        +
                      </Button>
                    </>
                  ) : (
                    <Button onClick={handleDeposit}>Stake</Button>
                  )}
                </Row>
              </Col>
            </Row>
          </>
        ) : (
          <Row justify="center">
            <Button type="primary" onClick={approve}>
              Approve Contract
            </Button>
          </Row>
        )}
        <hr />
        {showDetails ? (
          <>
            <Row
              justify="center"
              className="cursor"
              onClick={() => setShowDetails(false)}
            >
              <Text>
                Hide <i className="bi bi-caret-up-fill"></i>
              </Text>
            </Row>
            <Row>{details}</Row>
          </>
        ) : (
          <Row
            justify="center"
            className="cursor"
            onClick={() => setShowDetails(true)}
          >
            <Text>
              Details <i className="bi bi-caret-down-fill"></i>
            </Text>
          </Row>
        )}
      </Card>
    </>
  );
};
